<div class="ipm-july-offer-modal">

  <!-- Header gradient strip -->
  <div class="offer-modal-header">
    <div class="offer-header-glow"></div>
    <span class="offer-header-emoji">🎁</span>
    <h2 class="offer-modal-title">Spend Once. Promote Twice.</h2>
    <p class="offer-modal-subtitle">Get 100% of your July campaign spend back</p>
    <button class="offer-modal-close" (click)="close()">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="offer-modal-body">

    <!-- Countdown -->
    <div class="offer-countdown" *ngIf="!isExpired">
      <span class="countdown-label">Offer ends in</span>
      <div class="countdown-pills">
        <div class="pill">
          <span class="pill-value">{{ daysLeft }}</span>
          <span class="pill-unit">Days</span>
        </div>
        <div class="pill-sep">:</div>
        <div class="pill">
          <span class="pill-value">{{ hoursLeft }}</span>
          <span class="pill-unit">Hrs</span>
        </div>
        <div class="pill-sep">:</div>
        <div class="pill">
          <span class="pill-value">{{ minutesLeft }}</span>
          <span class="pill-unit">Min</span>
        </div>
      </div>
    </div>
    <div class="offer-expired-badge" *ngIf="isExpired">
      <i class="pi pi-times-circle"></i> Offer Expired
    </div>

    <!-- Main description -->
    <div class="offer-description">
      <p class="offer-headline">
        Add funds and use them on Beat22 Campaigns before 31st July 2026.
        The amount spent will be credited back to your Campaign Wallet by 31st August 2026.
      </p>
      <ul class="offer-points">
        <li>
          <i class="pi pi-check-circle"></i>
          <span>Add funds before 31st July</span>
        </li>
        <li>
          <i class="pi pi-check-circle"></i>
          <span>Use the funds before 31st July</span>
        </li>
        <li>
          <i class="pi pi-check-circle"></i>
          <span>Get 100% of the spent amount back by 31st August</span>
        </li>
        <li>
          <i class="pi pi-check-circle"></i>
          <span>Use the credited balance to boost more beats</span>
        </li>
      </ul>
    </div>

  </div>

  <!-- CTA footer -->
  <div class="offer-modal-footer">
    <button class="offer-cta-primary" (click)="onAddFunds()">
      <i class="pi pi-plus me-1"></i>
      Add Funds &amp; Earn Back
    </button>
    <button class="offer-cta-secondary" (click)="close()">
      Maybe Later
    </button>
  </div>

</div>
